import {Pipe, PipeTransform} from '@angular/core';
import {Months} from '../../supervision-management/compliance-items/compliance-item/enums/months.enum';
@Pipe({
    name: 'monthDisplay',
    pure: false
})
export class MonthDisplayPipe implements PipeTransform {
    constructor() {}

    transform(month: any): string {
        let retval: string = '';

        switch (Number(month)) {
            case Months.JANUARY:
                retval = 'January';
                break;

            case Months.FEBRUARY:
                retval = 'February';
                break;

            case Months.MARCH:
                retval = 'March';
                break;

            case Months.APRIL:
                retval = 'April';
                break;

            case Months.MAY:
                retval = 'May';
                break;

            case Months.JUNE:
                retval = 'June';
                break;

            case Months.JULY:
                retval = 'July';
                break;

            case Months.AUGUST:
                retval = 'August';
                break;

            case Months.SEPTEMBER:
                retval = 'September';
                break;

            case Months.OCTOBER:
                retval = 'October';
                break;

            case Months.NOVEMBER:
                retval = 'November';
                break;

            case Months.DECEMBER:
                retval = 'December';
                break;
        }

        return retval;
    }
}